import { render } from "./Customer3.vue?vue&type=template&id=a08585e4"
import script from "./Customer3.vue?vue&type=script&lang=js"
export * from "./Customer3.vue?vue&type=script&lang=js"

import "./Customer3.vue?vue&type=style&index=0&id=a08585e4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__